(function ($) {
	/**
	 * Remove the sidebar if there is no content navigation items.
	 * Anchorific adds an empty list, so we need to check for this.
	 */

	/**
	 * Add content navigation.
	 *
	 * @link https://github.com/renettarenula/anchorific.js/
	 */
	$(".article .content-main").anchorific({
		navigation: "#content-nav",
		headers:
			".show-heading-in-content-nav h1, .show-heading-in-content-nav h2, .show-heading-in-content-nav h3, .show-heading-in-content-nav h4, .show-heading-in-content-nav h5, .show-heading-in-content-nav h6",
		speed: 200,
		anchorClass: "content-navigation-anchor",
		anchorText: "#",
		top: ".scroll-to-top",
		spy: true,
		position: "append",
		spyOffset: "150",
		navElements: [],
	});
})(jQuery);
